import { render } from "./editQuestion.vue?vue&type=template&id=e9a65d3c"
import script from "./editQuestion.vue?vue&type=script&lang=js"
export * from "./editQuestion.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__